import { useState, useEffect, useCallback } from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import i18n from '../../i18n';
import { SUPPORTED_LANGUAGES } from '../../languages';

function normalizeLanguage(lng) {
  if (!lng) {
    return SUPPORTED_LANGUAGES[0].code;
  }

  if (SUPPORTED_LANGUAGES.some(l => l.code === lng)) {
    return lng;
  }

  const primary = lng.split('-')[0].toLowerCase();
  const byPrimary = SUPPORTED_LANGUAGES.find(l => l.code === primary);
  if (byPrimary) {
    return byPrimary.code;
  }

  const fallback = i18n.options.fallbackLng;
  const fallbackCode = Array.isArray(fallback) ? fallback[0] : fallback;
  return SUPPORTED_LANGUAGES.some(l => l.code === fallbackCode) ? fallbackCode : SUPPORTED_LANGUAGES[0].code;
}

function updateUrlLangParam(code) {
  const params = new URLSearchParams(window.location.search);
  params.set('lang', code);
  const newUrl = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
  window.history.replaceState(null, '', newUrl);
}

function LanguageSwitcher() {
  const [currentLang, setCurrentLang] = useState(() => normalizeLanguage(i18n.language));

  useEffect(() => {
    const onLanguageChanged = (lng) => setCurrentLang(normalizeLanguage(lng));
    i18n.on('languageChanged', onLanguageChanged);
    return () => i18n.off('languageChanged', onLanguageChanged);
  }, []);

  const handleChange = useCallback((event) => {
    const code = event.target.value;
    i18n.changeLanguage(code);
    updateUrlLangParam(code);
  }, []);

  return (
    <FormControl size="small" variant="standard">
      <Select
        value={currentLang}
        onChange={handleChange}
        disableUnderline
        aria-label="Language"
        IconComponent={() => null}
        renderValue={() => <LanguageIcon fontSize="medium" sx={{ color: 'white', display: 'flex' }} />}
        sx={{
          color: 'white',
          '& .MuiSelect-select': {
            paddingRight: '8px !important',
            paddingTop: '8px'
          },
        }}
      >
        {SUPPORTED_LANGUAGES.map(({ code, label }) => (
          <MenuItem key={code} value={code}>{label}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher;
